<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">视频创作</div>
    </div>
    <div class="page-body">
      <div class="bodayTitle">选择出镜形象</div>
      <div class="videoList">
        <div
          class="videoListItem"
          v-for="(item, index) in videoList"
          :key="index"
          @click="clickVideo(item)"
        >
          <img
            v-if="videoClickItem.id && item.id == videoClickItem.id"
            src="@/assets/aiVideo/xhBackground.png"
            alt="#"
            class="videoListItemChange"
          />
          <img
            :src="item.fileImageUrl"
            alt="#"
            class="record-item-img"
            v-if="item.fileImageUrl"
          />
          <div v-else class="record-item-noImg">
            <div class="record-item-noImg-something" v-if="item.type">
              <img
                src="@/assets/aiVideo/add.png"
                alt="#"
                class="record-item-noImg-something-img"
              />
              <div>定制形象</div>
            </div>
          </div>
          <div class="videoListItem-name">{{ item.name }}</div>
        </div>
      </div>
      <div class="bodayTitle newTitleDiv">
        <div>选择声音</div>
        <img
          src="@/assets/aiVideo/refresh.png"
          alt="#"
          class="newTitleDivImg"
          @click="refreshClick"
        />
      </div>
      <div class="voiceList">
        <div class="addVoice" @click="goToAddVoice" v-if="this.voiceCount < 3">
          <img src="@/assets/aiVideo/add.png" alt="#" class="addVoiceImg" />
          <div class="addVoiceText">定制专属声音</div>
        </div>
        <VoiceItem
          v-for="voice in voiceList"
          :key="voice.id"
          :voice="voice"
          :editType="false"
          :deleteType="false"
          :changeClickType="true"
          :ref="`voiceItem_${voice.id}`"
          :voiceClickId="voiceClickItem.id"
          @request-play="handleRequestPlay"
          @play-error="handlePlayError"
          @change="changeClick"
        />
      </div>
    </div>
    <div class="bottom">
      <div class="bottomBtn" @click="toEnd">一键生成</div>
    </div>
    <div v-if="showModal" class="modal-overlay">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">制作中</div>
        <div class="modal-body">
          <div class="modal-text">
            AI视频生成预计需要8-10分钟，稍后请至创作记录查看！
          </div>
        </div>
        <div class="modal-confirm-div">
          <div @click="goHome" class="modal-confirm-btn">返回首页</div>
        </div>
      </div>
    </div>
		<LackModal v-if="showLackTipModal"  @closeModal="closeModal"/>
  </div>
</template>

<script>
import { pageAvatarInfo, queryVoice, createTHVideo, queryVoCount, aiVideo } from "@/api";
import VoiceItem from "@/components/voiceItem.vue";
import LackModal from "@/components/lackModal.vue";

export default {
  name: "videoCreation",
  components: { VoiceItem, LackModal },
  computed: {},
  data() {
    return {
      videoList: [],
      voiceList: [],
      videoClickItem: {},
      voiceClickItem: {},
      showModal: false,
      videoCount: "",
      voiceCount: "",
      showLackTipModal: false,
	    currentPlatform: '',
    };
  },
  mounted() {
	  document.title = "视频创作";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
    this.haveQueryVoCount();
    sessionStorage.setItem("formPage", "");
  },
  methods: {
    async refreshClick() {
      let data = await queryVoCount();
      this.videoCount = data.videoCount;
      this.voiceCount = data.voiceCount;
      this.haveVoiceList();
    },
    async haveQueryVoCount() {
      let data = await queryVoCount();
      this.videoCount = data.videoCount;
      this.voiceCount = data.voiceCount;
      this.haveVideoList();
      this.haveVoiceList();
    },
    // 返回按钮逻辑
    onBack() {
      this.$router.back();
      // this.$router.replace({
      //   path: "videoTextconfirm",
      //   query: { content: this.$route.query.text },
      // });
    },
    async haveVideoList() {
      const data = await pageAvatarInfo({
        pageNumber: 1,
        pageSize: 1000,
      });
      if (this.videoCount < 3) {
        this.videoList = [{ type: "add" }, ...data.records];
      } else {
        this.videoList = data.records;
      }
    },
    async haveVoiceList() {
      const data = await queryVoice({
        pageNum: 1,
        pageSize: 1000,
      });
      this.voiceList = data.records.map((e) => {
        return {
          ...e,
          name: e.name,
          url: e.copySoundUrl,
        };
      });
    },
    clickVideo(item) {
      if (item.type) {
        sessionStorage.setItem("formPage", "videoCreation");
        this.$router.push({
          path: "customAvatar",
          query: { formPath: "videoCreation" },
        });
      } else {
        this.videoClickItem = item;
      }
    },
    closeModal() {
      this.showLackTipModal = false;
    },
    // ✅ 主动暂停所有音频
    pauseAllVoices() {
      for (const voice of this.voiceList) {
        const refName = `voiceItem_${voice.id}`;
        const instances = this.$refs[refName];
        if (instances && Array.isArray(instances) && instances[0]) {
          instances[0].pause(); // v-for 中的 ref 是数组
        }
      }
      this.currentPlayingVoice = null;
    },
    // 协调播放：确保只有一个在播
    handleRequestPlay(voiceComponent) {
      if (
        this.currentPlayingVoice &&
        this.currentPlayingVoice !== voiceComponent
      ) {
        this.currentPlayingVoice.pause();
      }
      this.currentPlayingVoice = voiceComponent;
    },
    handlePlayError(error) {
      this.$toast && this.$toast("音频播放失败，请检查网络或浏览器权限");
    },
    goToAddVoice() {
      this.$router.push({
        path: "customVoice",
        query: { formPath: "videoCreation" },
      });
    },
    changeClick(voice) {
      this.voiceClickItem = voice;
    },
    async toEnd() {
      if (!this.videoClickItem.id) {
        return this.$toast && this.$toast("请选择形象");
      }
      if (!this.voiceClickItem.id) {
        return this.$toast && this.$toast("请选择声音");
      }
      if (!this.$route.query.text) {
        return this.$toast && this.$toast("请选择文本");
      }
      this.pauseAllVoices();
      let params = {
        avatarId: this.videoClickItem.id,
        soundId: this.voiceClickItem.id,
        text: this.$route.query.text,
      };
      
      let isShowLackModal = await aiVideo(params);
      if(isShowLackModal?.status == 'notAllowed'||isShowLackModal?.status == 'view'){
        this.showLackTipModal = true;
        return
      }
      let data = await createTHVideo(params);
      this.showModal = true;
      console.log(data, "data");
    },
    goHome() {
      this.showModal = false;
      this.$router.push({ path: "aiVideo" });
    },
  },
  beforeDestroy() {
    this.pauseAllVoices(); // 页面销毁前清理
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  /* overflow-y: auto; */
  padding: 5.333vw 4.2666vw 0 4.2666vw;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}
.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}
.videoList {
  margin-top: 3.8666vw;
  margin-bottom: 5.333vw;
  padding-left: 2vw;
  display: flex;
  /* align-items: center; */
  overflow-x: auto; /* 允许横向滚动 */
  -webkit-overflow-scrolling: touch;
}
.videoListItem {
  flex-shrink: 0;
  width: 25.6vw;
  /* height: 48vw; */
  border-radius: 2.1333vw;

  margin-right: 4.2666vw;
  position: relative;
  padding-top: 5px;
}
.record-item-img {
  width: 25.6vw;
  height: 48vw;
  border-radius: 2.1333vw;
  object-fit: cover;
}
.videoListItemChange {
  width: 27vw;
  height: 49.5vw;
  position: absolute;
  top: 1px;
  left: -1vw;
}
.record-item-noImg {
  width: 25.6vw;
  height: 48vw;
  border-radius: 2.1333vw;
  background-color: #f0f4f8;
  position: relative;
  box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.1);
}
.record-item-noImg-something {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.record-item-noImg-something > div {
  color: #1f2226;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 3.7333vw;
}
.record-item-noImg-something-img {
  width: 8vw;
  height: 8vw;
}
.videoListItem-name {
  color: #1f2226;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.6vw;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.voiceList {
  height: calc(100vh - 120vw);
  height: calc(100dvh - 120vw);
  margin-top: 3.2vw;
  overflow-y: auto;
}
.yyyp {
  margin-bottom: 3.2vw;
}
.addVoice {
  background-color: #d2dae4;
  box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  height: 13.333vw;
  margin-left: 2.666vw;
  margin-right: 2.666vw;
  border-radius: 1.6vw;
  padding: 0 4.8vw 0 4.2666vw;
  margin-bottom: 3.2vw;
}
.addVoiceImg {
  width: 5.333vw;
  height: 5.333vw;
  margin-right: 3.4666vw;
}
.addVoiceText {
  color: #1f2226;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4vw;
}
.bottomBtn {
  width: 53.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  line-height: 8vw;
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #2c2c2c60;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 72vw;
  height: 85.6vw;
  /* border-radius: 3.2vw; */
  /* background-color: #ffffff; */
  background-image: url("../../../assets/aiVideo/tcbj.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.modal-title {
  margin-top: 29vw;
  /* background: linear-gradient(136deg, #008dea 12%, #2566fc 64%); */
  font-size: 6.4vw;
  font-weight: bold;
  line-height: 7.46vw;
  text-align: center;
  font-variation-settings: "opsz" auto;
  background: linear-gradient(136deg, #008dea 12%, #2566fc 64%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 9.333vw 0 11.594vw;
}
.modal-text {
  /* min-width: 44.8vw; */
  color: #17204d;
  font-weight: 400;
  font-size: 4vw;
  line-height: 6.4vw;
  margin-top: 5.296vw;
  text-align: center;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
  padding-bottom: 5.333vw;
}
.modal-confirm-btn {
  margin-top: 8vw;
  width: 48.8vw;
  height: 12.8vw;
  border-radius: 53.33vw;
  opacity: 1;

  background: linear-gradient(108deg, #729eff 4%, #1f62fc 44%);

  box-shadow: inset 0.5px 0.5px 0px 0px #ffffff;
  color: #ffffff;
  font-size: 4.2666vw;
  font-weight: 500;
  line-height: 12.8vw;
  text-align: center;
}
.newTitleDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.newTitleDivImg {
  width: 5vw;
  height: 5vw;
}
</style>
